import { money } from "./format";

export const SELLER_URL = "https://www.facebook.com/amvhin.rod/";
export const SELLER_MESSENGER_URL = "https://www.messenger.com/t/61567154155885/";
export function messengerTarget(userAgent = navigator.userAgent) {
  const id = "61567154155885";
  if (/Android/i.test(userAgent)) {
    return `intent://user/${id}/#Intent;scheme=fb-messenger;package=com.facebook.orca;S.browser_fallback_url=${encodeURIComponent(`https://m.me/${id}`)};end`;
  }
  if (/iPhone|iPad|iPod/i.test(userAgent)) return `fb-messenger://user-thread/${id}`;
  return SELLER_MESSENGER_URL;
}

export function selectionSummary(row) {
  const items = row.line.items;
  if (!items) return "";
  return Object.entries(items)
    .map(([name, qty]) => `${qty} pc ${name}`)
    .join(", ");
}

export function quantityDetail({ item, pieces }) {
  if (item.deal && item.bundleQty) {
    const bundles = Math.floor(pieces / item.bundleQty);
    const rest = pieces % item.bundleQty;
    const parts = [];
    if (bundles) parts.push(`${bundles} × ${item.deal}`);
    if (rest) parts.push(`${rest} × ${money(item.price)} each`);
    return `Quantity: ${pieces}${parts.length ? ` (${parts.join(" + ")})` : ""}`;
  }
  return `Quantity: ${pieces}${item.saleUnit === "set" ? (pieces === 1 ? " set" : " sets") : ""} (${money(item.price)} ${item.saleUnit === "set" ? "per set" : "each"})`;
}

export function buildOrderText({ name, notes, rows, total }) {
  return [
    "Order Details for Inquiry (Not an Invoice)",
    name ? `Name: ${name}` : null,
    "",
    "Items",
    ...rows.flatMap((row, i) =>
      [
        `${i + 1}. ${row.item.name}`,
        selectionSummary(row) || null,
        quantityDetail(row),
        `Price: ${money(row.total)}`,
        "--------------------",
      ].filter(Boolean),
    ),
    `Total: ${money(total)}`,
    notes ? `Note to seller: ${notes}` : null,
  ]
    .filter((line) => line !== null)
    .join("\n");
}
